import React from "react";
import { Link } from "react-router-dom";

export const TERMS_VERSION = "2026-06-draft";

export function TermsAgree({ checked, onChange, testid = "terms-agree" }) {
  return (
    <label className="flex items-start gap-2 text-xs text-sam-slate" data-testid={testid}>
      <input type="checkbox" className="mt-0.5 accent-sam-crimson" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={`${testid}-checkbox`} />
      <span>I agree to the <Link to="/terms" target="_blank" rel="noreferrer" className="text-sam-crimson font-semibold underline">Terms of Service</Link>.</span>
    </label>
  );
}

export default TermsAgree;
